/**
 *  Controller pel Modal del llistat de centres adscrits per un servei educatiu
 *  @author RbSierra
 */

angular.module('mapes').controller('listCentresSEController', function (
  $scope,
  Ofertes,
  Configuracio,
  $uibModalInstance,
  $uibModal,
  centre,
  centresAdscritsSE,
  SharedProperties,
) {

  $scope.centre = centre;

  $scope.centresAdscritsSE = centresAdscritsSE;

  //Funcio OK que tanca la instància del Modal
  $scope.ok = function () {
    $uibModalInstance.close();
  }

  //RbSierra
  //Funció que crida el Modal que s'encarregarà de mostrar la informació dels ensenyaments pel centre SFP
  $scope.showOfertaCentreSFP = function (centre) {
    $uibModal.open(
      {
        animation: true,
        component: 'ajCentresSfp',
        size: 'lg',
        windowClass: 'center-modal',
        resolve: {
          ofertaCentreSFP: Ofertes.getOfertaCentre(centre),
          'centre': function () {
            return centre;
          },
          'selectorCurs': function () {
            return SharedProperties.getSelectedCurs();
          }

        }
      }
    )
    $uibModalInstance.close();
  };

  //Funció que fa que el mapa mostri el centres adscrits
  $scope.showCentresAdscritsInMap = function () {
    var objFilterBbox = setFilterAndBBox();
    //actualitzem el mapa amb el layer de centres (i no SE)
    mapesOl.updateMapGeoserver(objFilterBbox.filter, objFilterBbox.bboxObj, params.geoServerOfertaLayers);
    $uibModalInstance.close(); //tanquem el modal
    $("#tab-map-link").tab('show')
  }

  //Funció que fa set del filtre i bbox en funció dels centres adscrits
  function setFilterAndBBox() {
    var totalAdscrits = [];
    var bbox = [];
    var coordsX = [];
    var coordsY = [];
    var filter = "(1=1)";
    var offset = 100;

    var result = { filter: "", bboxObj: { bboxGeo: [], bboxCentre: [] } };

    if ($scope.centresAdscritsSE.length != 0) {
      filter += " AND (";
      //assignem al filtre tots el codis existents dins el total d'adscrits
      angular.forEach($scope.centresAdscritsSE, function (value, key) {
        if ($scope.checkCoords(value) == true) { //Assegurem de descartar centres sense coords
          if (key != 0) {
            filter += " OR ";
          }
          filter += "CODI_CENTRE= '" + value.codiCentre + "'";

          //set dels arrays amb totes les posicions X i Y
          coordsX.push(Number((value.coordX).replace(",", ".")));
          coordsY.push(Number((value.coordY).replace(",", ".")));
        }
      })
      filter += ")";
      //obtenim mins i max i apliquem un offset pel bbox del mapa
      var minX = Math.min.apply(null, coordsX) - offset;
      var minY = Math.min.apply(null, coordsY) - offset;
      var maxX = Math.max.apply(null, coordsX) + offset;
      var maxY = Math.max.apply(null, coordsY) + offset;

      bbox = [minX, minY, maxX, maxY];
    }
    //assignem el filtre i el bbox a l'objecte de retorn
    result.filter = filter;
    result.bboxObj.bboxGeo = bbox;

    return result;
  };

  $scope.centerAdscrit = function (elem) {
    if ($scope.checkCoords(elem) == true) {
      var newFilter = "(1=1)";
      var bboxObj = { bboxGeo: [], bboxCentre: [] };
      var offset = 100;
      //Contruïm el nou filtre que mostrarà el centre al mapa i esborrarà la resta de centres		
      newFilter += " AND (";
      newFilter += "CODI_CENTRE= '" + elem.codiCentre + "'";
      newFilter += ")";

      //convertim les coordenades a format decimal 99999.99
      var coordX = Number((elem.coordX).replace(",", "."));
      var coordY = Number((elem.coordY).replace(",", "."));
      //obtenim mins i max per a ajustar la finestra bbox del mapa	
      var minX = coordX - offset;
      var minY = coordY - offset;
      var maxX = coordX + offset;
      var maxY = coordY + offset;

      bboxObj.bboxCentre = [minX, minY, maxX, maxY];
      //actualitzem el mapa amb el layer de centres (i no SE)
      mapesOl.updateMapGeoserver(newFilter, bboxObj, params.geoServerOfertaLayers);
      $uibModalInstance.close();
      $("#tab-map-link").tab('show')
    }
  }

  $scope.checkCoords = function (elem) {
    var areCoordsNotified = true;
    if (elem.coordX == null || elem.coordY == null || elem.coordX == ""
      || elem.coordY == "") {
      areCoordsNotified = false;
    }

    return areCoordsNotified;
  }

  $scope.openWindow = function (centre) {
    $uibModal.open(
      {
        animation: true,
        component: 'ajFitxaCentre',
        size: 'xl',
        resolve: { centre },
      }
    );
  }

});